import React, { useState } from 'react';
import useForm from '../../Hooks/useForm.js';
import Input from '../Forms/Input.js';
import styles from './DadosParaContrato.module.css';
import enviarEmail from '../Email/Email.js';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';

const DadosParaContrato = () => {
  const razaoSocial = useForm('');
  const nomeFantasia = useForm('');
  const documento = useForm('cpf/cnpj');
  const inscricaoEstadual = useForm('', false);
  const email = useForm('email');
  const emailRepresentante = useForm('email');
  const endereco = useForm('');
  const cidade = useForm('');
  const uf = useForm('');
  const cep = useForm('cep');
  const telefone = useForm('telefone');
  const representante = useForm('');
  const nascimentoRepresentante = useForm('');
  const cpfRepresentante = useForm('cpf');
  const cargo = useForm('');
  const testemunhaNome = useForm('');
  const testemunhaNascimento = useForm('');
  const testemunhaCpf = useForm('cpf');
  const testemunhaEmail = useForm('email');

  // Campos de módulos
  const [modulos, setModulos] = useState({
    atendimento: false,
    faturamento: false,
    nfse: false,
    estoque: false,
    financeiro: false,
    agendaWeb: false,
    whatsapp: false,
    hospedagem: false,
    hospedagemInfo: '',
    migracao: '', // Mudamos para string vazia
    migracaoInfo: '',
  });

  const [modalAberto, setModalAberto] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [cpfError, setCpfError] = useState('');
  const navigate = useNavigate();

  const limparErros = () => {
    setError('');
    setEmailError('');
    setCpfError('');
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setModulos((prev) => ({ ...prev, [name]: value }));
    limparErros();
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setModulos((prev) => ({ ...prev, [name]: checked }));
    limparErros();
  };

  const handleInfoChange = (e) => {
    const { name, value } = e.target;
    setModulos((prev) => ({ ...prev, [name]: value }));
    limparErros();
  };

  const limparCampos = () => {
    const campos = [
      razaoSocial,
      nomeFantasia,
      documento,
      inscricaoEstadual,
      email,
      emailRepresentante,
      endereco,
      cidade,
      uf,
      cep,
      telefone,
      representante,
      nascimentoRepresentante,
      cpfRepresentante,
      cargo,
      testemunhaNome,
      testemunhaNascimento,
      testemunhaCpf,
      testemunhaEmail,
    ];
    campos.forEach((campo) => campo.setValue(''));
    setModulos({
      atendimento: false,
      faturamento: false,
      nfse: false,
      estoque: false,
      financeiro: false,
      agendaWeb: false,
      whatsapp: false,
      hospedagem: false,
      hospedagemInfo: '',
      migracao: false,
      migracaoInfo: '',
    });
  };

  React.useEffect(() => {
    if (!modalAberto && enviado) {
      limparErros();
    }
  }, [modalAberto, enviado]);

  async function handleSubmit(e) {
    e.preventDefault();
    limparErros();

    // Verificação dos campos de detalhes
    const hospedagemNaoPreenchida =
      modulos.hospedagem && !modulos.hospedagemInfo.trim();
    const migracaoNaoPreenchida =
      modulos.atendimento &&
      (modulos.migracao === '' ||
        (modulos.migracao === 'sim' && !modulos.migracaoInfo.trim()));

    // Verifica se pelo menos um módulo foi selecionado
    const moduloSelecionado = Object.values(modulos).some(
      (value) =>
        value === true || (typeof value === 'string' && value.trim() !== ''),
    );

    // Valida todos os campos obrigatórios
    const campos = [
      razaoSocial,
      nomeFantasia,
      documento,
      email,
      emailRepresentante,
      endereco,
      cidade,
      uf,
      cep,
      telefone,
      representante,
      nascimentoRepresentante,
      cpfRepresentante,
      cargo,
      testemunhaNome,
      testemunhaNascimento,
      testemunhaCpf,
      testemunhaEmail,
    ];

    // Validação individual dos campos
    let camposInvalidos = [];
    let primeiroCampoInvalido = null;

    campos.forEach((campo) => {
      if (!campo.validate()) {
        camposInvalidos.push(campo);
        if (!primeiroCampoInvalido) {
          primeiroCampoInvalido = campo;
        }
      }
    });

    // Validação da inscrição estadual se tiver valor
    if (inscricaoEstadual.value && !inscricaoEstadual.validate()) {
      camposInvalidos.push(inscricaoEstadual);
      if (!primeiroCampoInvalido) {
        primeiroCampoInvalido = inscricaoEstadual;
      }
    }

    // Verifica se e-mails e CPFs são diferentes
    const emailsIguais =
      emailRepresentante.value &&
      testemunhaEmail.value &&
      emailRepresentante.value === testemunhaEmail.value;
    const cpfsIguais =
      cpfRepresentante.value &&
      testemunhaCpf.value &&
      cpfRepresentante.value === testemunhaCpf.value;

    if (emailsIguais) {
      setEmailError('E-mails da devem ser diferentes');
    }

    if (cpfsIguais) {
      setCpfError('CPFs devem ser diferentes');
    }

    // Lógica para exibir erros globais
    const errosTotais =
      camposInvalidos.length +
      (hospedagemNaoPreenchida ? 1 : 0) +
      (migracaoNaoPreenchida ? 1 : 0) +
      (!moduloSelecionado ? 1 : 0);

    if (errosTotais > 0 || emailsIguais || cpfsIguais) {
      let mensagemErro = '';

      // Prioriza mostrar erros de campos não preenchidos
      if (
        camposInvalidos.length > 0 ||
        hospedagemNaoPreenchida ||
        migracaoNaoPreenchida
      ) {
        mensagemErro = 'Preencha todos os campos corretamente';
      }
      // Mostra erros específicos se forem os únicos erros
      else if (emailsIguais && cpfsIguais) {
        mensagemErro = 'E-mails e CPFs devem ser diferentes';
      } else if (emailsIguais) {
        mensagemErro = 'E-mails devem ser diferentes';
      } else if (cpfsIguais) {
        mensagemErro = 'CPFs devem ser diferentes';
      } else if (!moduloSelecionado) {
        mensagemErro = 'Nenhum módulo selecionado para contratação';
      }

      setError(mensagemErro);
      return;
    }

    setLoading(true);

    const sucesso = await enviarEmail.enviarEmailContrato({
      razaoSocial: razaoSocial.value,
      nomeFantasia: nomeFantasia.value,
      documento: documento.value,
      inscricaoEstadual: inscricaoEstadual.value,
      email: email.value,
      emailRepresentante: emailRepresentante.value,
      endereco: endereco.value,
      cidade: cidade.value,
      uf: uf.value,
      cep: cep.value,
      telefone: telefone.value,
      representante: representante.value,
      nascimentoRepresentante: nascimentoRepresentante.value,
      cpfRepresentante: cpfRepresentante.value,
      cargo: cargo.value,
      testemunhaNome: testemunhaNome.value,
      testemunhaNascimento: testemunhaNascimento.value,
      testemunhaCpf: testemunhaCpf.value,
      testemunhaEmail: testemunhaEmail.value,
      modulosSelecionados: modulos,
    });

    setLoading(false);
    setEnviado(sucesso);
    if (sucesso) {
      setModalAberto(true);
    } else {
      setError('Erro ao enviar o formulário. Tente novamente.');
    }
  }

  // Constantes para controle dos checkboxes dependentes
  const podeSelecionarAgendaWhatsapp = modulos.atendimento;
  const podeSelecionarHospedagem =
    modulos.atendimento ||
    modulos.faturamento ||
    modulos.nfse ||
    modulos.estoque ||
    modulos.financeiro;
  const podeSelecionarMigracao = modulos.atendimento; // Agora depende apenas de atendimento

  return (
    <>
      <Modal
        isOpen={modalAberto}
        onRequestClose={() => {
          setModalAberto(false);
          setTimeout(() => navigate('/'), 100);
          // Limpar qualquer instância do ScrollTrigger/GSAP antes de navegar
          if (window.ScrollTrigger) {
            window.ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
          }
          setModalAberto(false);
          navigate('/');
        }}
        className={styles.modal}
        overlayClassName={styles.modalOverlay}
      >
        <h2>Sucesso!</h2>
        <p>Seus dados foram enviados com sucesso!</p>
        <button onClick={() => navigate('/')}>Fechar</button>
      </Modal>

      <h1 className={styles.titulo}>
        Dados para a contratação <span className={styles.point}>.</span>
      </h1>

      <div className={styles.container}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <Input
            classe="col2"
            label="Razão Social"
            name="razaoSocial"
            {...razaoSocial}
            onChange={(e) => {
              razaoSocial.onChange(e);
              limparErros();
            }}
          />
          <Input
            classe="col2"
            label="Nome Fantasia"
            name="nomeFantasia"
            {...nomeFantasia}
            onChange={(e) => {
              nomeFantasia.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="CNPJ/CPF"
            name="documento"
            maxLength="18"
            {...documento}
            onChange={(e) => {
              documento.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="Inscrição Estadual"
            name="inscricaoEstadual"
            maxLength={20}
            {...inscricaoEstadual}
            onChange={(e) => {
              inscricaoEstadual.onChange(e);
              limparErros();
            }}
          />
          <label className={styles.label}>
            UF
            <select
              name="uf"
              value={uf.value}
              onChange={(e) => {
                const valor = e.target.value;
                uf.onChange({ target: { value: valor } });
                limparErros();

                // Quando NÃO for DF, desmarca NF-e automaticamente
                if (valor !== 'DF') {
                  setModulos((prev) => ({
                    ...prev,
                    nfse: false,
                  }));
                }
              }}
              className={styles.select}
            >
              <option>Selecione...</option>
              {[
                'AC',
                'AL',
                'AP',
                'AM',
                'BA',
                'CE',
                'DF',
                'ES',
                'GO',
                'MA',
                'MT',
                'MS',
                'MG',
                'PA',
                'PB',
                'PR',
                'PE',
                'PI',
                'RJ',
                'RN',
                'RS',
                'RO',
                'RR',
                'SC',
                'SP',
                'SE',
                'TO',
              ].map((estado) => (
                <option key={estado} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </label>

          {/* <Input
            label="UF"
            name="uf"
            maxLength="2"
            {...uf}
            onChange={(e) => {
              const valorMaiusculo = e.target.value.toUpperCase();
              uf.onChange({ target: { value: valorMaiusculo } });
              limparErros();
            }}
          /> */}
          <Input
            label="CEP"
            name="cep"
            maxLength="9"
            {...cep}
            onChange={(e) => {
              cep.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="Cidade"
            name="cidade"
            {...cidade}
            onChange={(e) => {
              cidade.onChange(e);
              limparErros();
            }}
          />
          <Input
            classe="col2"
            label="Endereço"
            name="endereco"
            {...endereco}
            onChange={(e) => {
              endereco.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="Telefone"
            name="telefone"
            maxLength="15"
            {...telefone}
            onChange={(e) => {
              telefone.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="Email"
            name="email"
            type="email"
            {...email}
            onChange={(e) => {
              email.onChange(e);
              limparErros();
            }}
          />

          <Input
            classe="col2"
            label="Representante Legal"
            name="representante"
            {...representante}
            onChange={(e) => {
              representante.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="E-mail do Representante Legal"
            name="emailRepresentante"
            type="email"
            {...emailRepresentante}
            onChange={(e) => {
              emailRepresentante.onChange(e);
              emailRepresentante.validate();
              limparErros();
              if (
                testemunhaEmail.value &&
                e.target.value === testemunhaEmail.value
              ) {
                setEmailError('E-mails devem ser diferentes');
              } else {
                setEmailError('');
              }
            }}
            onBlur={emailRepresentante.onBlur}
            error={emailRepresentante.error || emailError}
          />
          <Input
            label="Nascimento Representante"
            name="nascimentoRepresentante"
            type="date"
            {...nascimentoRepresentante}
            onChange={(e) => {
              nascimentoRepresentante.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="CPF Representante"
            name="cpfRepresentante"
            maxLength="14"
            {...cpfRepresentante}
            onChange={(e) => {
              cpfRepresentante.onChange(e);
              cpfRepresentante.validate();
              limparErros();
              if (
                testemunhaCpf.value &&
                e.target.value === testemunhaCpf.value
              ) {
                setCpfError('CPFs devem ser diferentes');
              } else {
                setCpfError('');
              }
            }}
            onBlur={cpfRepresentante.onBlur}
            error={cpfRepresentante.error || cpfError}
          />
          <Input
            label="Cargo"
            name="cargo"
            {...cargo}
            onChange={(e) => {
              cargo.onChange(e);
              limparErros();
            }}
          />

          <Input
            classe="col2"
            label="Nome da Testemunha"
            name="testemunhaNome"
            {...testemunhaNome}
            onChange={(e) => {
              testemunhaNome.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="Nascimento Testemunha"
            name="testemunhaNascimento"
            type="date"
            {...testemunhaNascimento}
            onChange={(e) => {
              testemunhaNascimento.onChange(e);
              limparErros();
            }}
          />
          <Input
            label="CPF Testemunha"
            name="testemunhaCpf"
            maxLength="14"
            {...testemunhaCpf}
            onChange={(e) => {
              testemunhaCpf.onChange(e);
              testemunhaCpf.validate();
              limparErros();
              if (
                cpfRepresentante.value &&
                e.target.value === cpfRepresentante.value
              ) {
                setCpfError('CPFs devem ser diferentes');
              } else {
                setCpfError('');
              }
            }}
            onBlur={testemunhaCpf.onBlur}
            error={testemunhaCpf.error || cpfError}
          />
          <Input
            label="Email da Testemunha"
            name="testemunhaEmail"
            type="email"
            {...testemunhaEmail}
            onChange={(e) => {
              testemunhaEmail.onChange(e);
              testemunhaEmail.validate();
              limparErros();
              if (
                emailRepresentante.value &&
                e.target.value === emailRepresentante.value
              ) {
                setEmailError('E-mails devem ser diferentes');
              } else {
                setEmailError('');
              }
            }}
            onBlur={testemunhaEmail.onBlur}
            error={testemunhaEmail.error || emailError}
          />

          <div className={`${styles.checkboxGroup} ${styles.col2}`}>
            <div className={styles.titulo2}>
              <h2>SELECIONE OS MÓDULOS:</h2>
            </div>
            <div className={styles.checkboxContainer}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.atendimento}
                  onChange={handleCheckboxChange}
                  name="atendimento"
                />
                Atendimento
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.faturamento}
                  onChange={handleCheckboxChange}
                  name="faturamento"
                />
                Faturamento
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.nfse}
                  onChange={handleCheckboxChange}
                  name="nfse"
                  disabled={uf.value !== 'DF'} // NF-e só habilita para DF
                />
                NFS-e
                {uf.value !== 'DF' && (
                  <span className={styles.hint}>
                    (Disponível apenas para o DF)
                  </span>
                )}
              </label>

              {/* <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.nfse}
                  onChange={handleCheckboxChange}
                  name="nfse"
                />
                NFS-e
              </label> */}
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.estoque}
                  onChange={handleCheckboxChange}
                  name="estoque"
                />
                Estoque
              </label>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={modulos.financeiro}
                  onChange={handleCheckboxChange}
                  name="financeiro"
                />
                Financeiro
              </label>
              <label
                className={styles.checkboxLabel}
                style={{
                  opacity: podeSelecionarAgendaWhatsapp ? 1 : 0.6,
                  pointerEvents: podeSelecionarAgendaWhatsapp ? 'auto' : 'none',
                }}
              >
                <input
                  type="checkbox"
                  checked={modulos.agendaWeb}
                  onChange={handleCheckboxChange}
                  name="agendaWeb"
                  disabled={!podeSelecionarAgendaWhatsapp}
                />
                Agenda WEB
                {!podeSelecionarAgendaWhatsapp && (
                  <span className={styles.hint}>
                    (Apenas módulo Atendimento)
                  </span>
                )}
              </label>
              <label
                className={styles.checkboxLabel}
                style={{
                  opacity: podeSelecionarAgendaWhatsapp ? 1 : 0.6,
                  pointerEvents: podeSelecionarAgendaWhatsapp ? 'auto' : 'none',
                }}
              >
                <input
                  type="checkbox"
                  checked={modulos.whatsapp}
                  onChange={handleCheckboxChange}
                  name="whatsapp"
                  disabled={!podeSelecionarAgendaWhatsapp}
                />
                Envio de Mensagem WhatsApp (disparo programado)
                {!podeSelecionarAgendaWhatsapp && (
                  <span className={styles.hint}>
                    (Apenas módulo Atendimento)
                  </span>
                )}
              </label>

              <label
                className={styles.checkboxLabel}
                style={{
                  opacity: podeSelecionarHospedagem ? 1 : 0.6,
                  pointerEvents: podeSelecionarHospedagem ? 'auto' : 'none',
                }}
              >
                <input
                  type="checkbox"
                  checked={modulos.hospedagem}
                  onChange={handleCheckboxChange}
                  name="hospedagem"
                  disabled={!podeSelecionarHospedagem}
                />
                Hospedagem em nuvem
                {!podeSelecionarHospedagem && (
                  <span className={styles.hint}>(Selecione algum módulo)</span>
                )}
              </label>
              {modulos.hospedagem && (
                <div className={styles.inputGroup}>
                  <Input
                    label="Informar detalhes da hospedagem*"
                    name="hospedagemInfo"
                    type="text"
                    placeholder="Ex: Nome do servidor, link, etc"
                    value={modulos.hospedagemInfo}
                    onChange={({ target }) => {
                      setModulos({ ...modulos, hospedagemInfo: target.value });
                      limparErros();
                    }}
                  />
                  {modulos.hospedagem && !modulos.hospedagemInfo.trim() && (
                    <p className={styles.fieldError}>
                      Este campo é obrigatório
                    </p>
                  )}
                </div>
              )}
            </div>

            {modulos.atendimento && (
              <div className={styles.inputGroup}>
                <label className={styles.checkboxLabel}>
                  Haverá migração de outro sistema?*
                </label>
                <select
                  name="migracao"
                  value={modulos.migracao}
                  onChange={handleSelectChange}
                  className={styles.select}
                  required={modulos.atendimento}
                >
                  <option value="">Selecione...</option>
                  <option value="sim">Sim</option>
                  <option value="nao">Não</option>
                </select>
                {modulos.migracao === 'sim' && (
                  <Input
                    label="Informar detalhes da migração*"
                    name="migracaoInfo"
                    type="text"
                    placeholder="Ex: Nome do sistema anterior, tipo de dados"
                    value={modulos.migracaoInfo}
                    onChange={handleInfoChange}
                  />
                )}
                {modulos.atendimento && modulos.migracao === '' && (
                  <p className={styles.fieldError}>Este campo é obrigatório</p>
                )}
                {modulos.migracao === 'sim' && !modulos.migracaoInfo.trim() && (
                  <p className={styles.fieldError}>Este campo é obrigatório</p>
                )}
              </div>
            )}
          </div>

          <button className={styles.button} disabled={loading}>
            {loading ? 'ENVIANDO...' : 'ENVIAR FORMULÁRIO'}
          </button>
          <p className={styles.error}>{error}</p>
        </form>
      </div>
    </>
  );
};

export default DadosParaContrato;
